import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import HomePage from "./pages/HomePage";
import Privacy from "./pages/Privacy";
import About from "./pages/About";
import { useEffect, useState } from "react";
import MainLayout from "./layout/MainLayout";
import TermsPage from "./pages/TermsPage";
import RefundPolicy from "./pages/RefundPolicy";
import Loader from "./components/Loader";
import LoginPage from "./pages/auth/LoginPage";
import SignupPage from "./pages/auth/SignupPage";
import ForgetPage from "./pages/auth/ForgetPage";
import CityTour from "./pages/CityTour";
import SundayCityTour from "./pages/SundayCityTour";
import CityTourDetails from "./pages/CityTourDetails";
import SundayCityTourDetails from "./pages/SundayCityTourDetails";
import Trips from "./pages/Trips";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import BookingPage from "./pages/BookingPage";
import PaymentPage from "./pages/PaymentPage";
import ProtectedRoute, { BookingFlowProtectedRoute } from "./components/ProtectedRoute";
import Profile from "./pages/auth/Profile";
import NotFound from "./pages/NotFound";
import { Toaster } from "react-hot-toast";
import BookingHistory from "./pages/BookingHistory";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [loading, setLoading] = useState(() => {
    return !sessionStorage.getItem("hasVisited");
  });

  useEffect(() => {
    if (loading) {
      const timer = setTimeout(() => {
        setLoading(false);
        sessionStorage.setItem("hasVisited", "true");
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  if (loading) return <Loader />;

  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<HomePage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="signup" element={<SignupPage />} />
            <Route path="forget" element={<ForgetPage />} />
            <Route path="about" element={<About />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="booking" element={<BookingPage />} />
            <Route path="terms" element={<TermsPage />} />
            <Route path="refund-policy" element={<RefundPolicy />} />
            <Route path="city-tour" element={<CityTour />} />
            <Route path="city-tour-details" element={<CityTourDetails />} />
            <Route path="sunday-city-tour" element={<SundayCityTour />} />
            <Route path="sunday-city-tour-details" element={<SundayCityTourDetails />} />
            <Route path="trips" element={<Trips />} />
            <Route path="blog" element={<Blog />} />
            <Route path="contact" element={<Contact />} />
            <Route path="profile" element={<Profile />} />
            <Route path="bookinghistory" element={<BookingHistory />} />

            <Route element={<ProtectedRoute />}>
              <Route path="booking" element={<BookingPage />} />
            </Route>

            <Route element={<BookingFlowProtectedRoute />}>
              <Route path="payment" element={<PaymentPage />} />
            </Route>
            <Route path="*" element={<NotFound />} />
            {/* <Route path="admin" element={<AdminDashboard />} /> */}
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </>
  );
}

export default App;